import { Box, useTheme } from "@mui/material";
import WarningAmberIcon from '@mui/icons-material/WarningAmber';


const ArchivedBanner: React.FC = () => {
  const theme = useTheme();

  return (
    <Box
      sx={{
        position: 'sticky',
        backgroundColor: theme.palette.error.main,
        color: 'white',
        textAlign: 'center',
        fontWeight: 600,
        fontSize: '0.95rem',
        py: 1.5,
        mb: 2,
        borderRadius: 1,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        gap: 1
      }}
    >
      <WarningAmberIcon sx={{ fontSize: '1.2rem' }} />
      This vehicle has been archived. Images may take longer to fetch.
    </Box>
  );
};

export default ArchivedBanner;
